import http from './http'

const basePath = '/achievement/softwareCopyright'

const normalizeBody = (idOrPayload, payload) =>
  typeof idOrPayload === 'object' && idOrPayload !== null ? idOrPayload : { ...(payload || {}), id: idOrPayload }

const withId = (id) => `${basePath}/${id}`

export async function saveSoftware(payload) {
  const res = await http.post(`${basePath}/saveDraft`, payload)
  return res.data
}

export async function submitSoftware(payload) {
  const res = await http.post(`${basePath}/submit`, payload)
  return res.data
}

export async function createSoftware(payload) {
  return payload?.isDraft ? saveSoftware(payload) : submitSoftware(payload)
}

export async function updateSoftware(idOrPayload, payload) {
  const body = normalizeBody(idOrPayload, payload)
  if (typeof body?.isDraft === 'boolean') {
    return body.isDraft ? saveSoftware(body) : submitSoftware(body)
  }
  const res = await http.put(basePath, body)
  return res.data
}

export async function getSoftware(id) {
  const res = await http.get(withId(id))
  return res.data
}

export async function listSoftwares(params) {
  const res = await http.get(basePath, { params })
  return res.data
}

export async function deleteSoftware(id) {
  const res = await http.delete(withId(id))
  return res.data
}
